import { ComponentType } from 'react';

import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { Button } from '@hh.ru/magritte-ui-button';
import { ArrowPathClockwiseSize24 } from '@hh.ru/magritte-ui-icon/variants/icon';
import { InnerErrorTrls } from '@hh.ru/magritte-ui-select/types';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';
import { Title } from '@hh.ru/magritte-ui-title';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './select-error.less';

export const SelectError: ComponentType<{ innerErrorTrls: InnerErrorTrls; reload: VoidFunction }> = ({
    innerErrorTrls,
    reload,
}) => {
    const { isMobile } = useBreakpoint();
    if (isMobile) {
        return (
            <div className={styles.errorContainer}>
                <Title Element={'h3'} size="small">
                    {innerErrorTrls.title}
                </Title>
                <VSpacing default={8} />
                <Text typography="paragraph-2-regular" style="secondary">
                    {innerErrorTrls.description}
                </Text>
            </div>
        );
    }
    return (
        <div className={styles.errorContainer} data-qa="magritte-select-error">
            <Title Element={'h3'} size="small">
                {innerErrorTrls.title}
            </Title>
            <VSpacing default={8} />
            <Text typography="paragraph-2-regular" style="secondary">
                {innerErrorTrls.description}
            </Text>
            <VSpacing default={32} />
            <Button mode="primary" style="accent" size="medium" onClick={reload} icon={<ArrowPathClockwiseSize24 />}>
                {innerErrorTrls.reloadButton}
            </Button>
        </div>
    );
};
